import ApiRoutes from '../routes/ApiRoutes';
import FetchHelper from '../utils/fetchHelper';

const CountryApi = {
  show: async (params = {}) => {
    const url = ApiRoutes.countryApiUrl();
    const response = await FetchHelper.get(url, params, {
      camelizeResponse: true,
    });
    return response;
  },
};

export default CountryApi;
